import { Loader, Stack, Switch } from '@mantine/core';
import { useEffect, useState } from 'react';
import { USER_RIGHT_LABELS, USER_RIGHTS, UserRight } from '../constants/userRights';
import { getAccessToken } from '../helpers/TokenRefresh';

type UserRightsEditProps = {
  personId: number;
};

const ALL_RIGHTS = Object.values(USER_RIGHTS) as UserRight[];

const apiUrl = import.meta.env.VITE_X_API_URL || '';

async function fetchWithAuth(url: string, init?: RequestInit) {
  const token = await getAccessToken();
  return fetch(url, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      ...init?.headers,
    },
  });
}

const UserRightsEdit: React.FC<UserRightsEditProps> = ({ personId }) => {
  const [rights, setRights] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchWithAuth(`${apiUrl}/person/${personId}/rights`)
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => setRights(data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [personId]);

  const handleToggle = async (key: string) => {
    const updated = rights.includes(key)
      ? rights.filter((r) => r !== key)
      : [...rights, key];
    setRights(updated);
    await fetchWithAuth(`${apiUrl}/person/${personId}/rights`, {
      method: 'PUT',
      body: JSON.stringify({ rights: updated }),
    }).catch(() => {});
  };

  if (loading) return <Loader size="sm" mt="md" />;

  return (
    <Stack gap="sm">
      {ALL_RIGHTS.map((right) => (
        <Switch
          key={right}
          label={USER_RIGHT_LABELS[right]}
          checked={rights.includes(right)}
          onChange={() => handleToggle(right)}
        />
      ))}
    </Stack>
  );
};

export default UserRightsEdit;
